/*
 * Audio Stream Controller
*/

//import BinarySearch from '../utils/binary-search';
import BufferHelper from '../helper/buffer-helper';
import Demuxer from '../demux/demuxer';
import Event from '../events';
import EventHandler from '../event-handler';
import TimeRanges from '../utils/timeRanges';
import { ErrorTypes, ErrorDetails } from '../errors';
import { logger } from '../utils/logger';

const State = {
	STOPPED : 'STOPPED',
	STARTING : 'STARTING',
	IDLE : 'IDLE',
	PAUSED : 'PAUSED',
	KEY_LOADING : 'KEY_LOADING',
	FRAG_LOADING : 'FRAG_LOADING',
	FRAG_LOADING_WAITING_RETRY : 'FRAG_LOADING_WAITING_RETRY',
	WAITING_TRACK : 'WAITING_TRACK',
	PARSING : 'PARSING',
	PARSED : 'PARSED',
	BUFFER_FLUSHING : 'BUFFER_FLUSHING',
	ENDED : 'ENDED',
	ERROR : 'ERROR',
	WAITING_INIT_PTS : 'WAITING_INIT_PTS',
};

class AudioStreamController extends EventHandler {

	constructor(hls) {
		super(hls,
			Event.MEDIA_ATTACHED,
			Event.MEDIA_DETACHING,
			Event.AUDIO_TRACKS_UPDATED,
			Event.AUDIO_TRACK_SWITCHING,
			Event.AUDIO_TRACK_LOADED,
			//Mactrix additions start
			Event.STREAM_ALL_LEVELS_LOADED,
			Event.STREAM_DESYNC,
			Event.FRAG_BUFFERED,
			Event.MANIFEST_LOADED,
			//Mactrix additions end
			Event.KEY_LOADED,
			Event.FRAG_LOADED,
			Event.FRAG_PARSING_INIT_SEGMENT,
			Event.FRAG_PARSING_DATA,
			Event.FRAG_PARSED,
			Event.ERROR,
			Event.BUFFER_CREATED,
			Event.BUFFER_APPENDED,
			Event.BUFFER_FLUSHED,
			Event.BUFFER_WAIT,
			Event.INIT_PTS_FOUND,
			Event.SEEK_READY
		);

		this.config = hls.config;
		this.audioCodecSwap = false;
		this.ticks = 0;
		this._state = State.STOPPED;
		this.ontick = this.tick.bind(this);
		this.initPTS = [];
		this.waitingFragment = null;
		this.forceStopFetching = false;
		this.allLevelsLoaded = false;
		this.videoFragBuffered = false;
		this._fragBufferCount = 0;
		this._pausedTimer = true;
		this._flushOnStoppedBuffering = {};
		this._skipAppendAfterFlush = false;
		this._waitForFlush = false;
		this._bufferBeforeSeekingTime = undefined;
		this._bufferBeforeSeekingApplied = undefined;
		this._videoSeekReady = undefined;
		this._audioSwitchComplete = true;
		this._parsingDataCount = 0;
	}

	destroy() {
		this.stopLoad();
		this.pauseController();

		EventHandler.prototype.destroy.call(this);
	/*
	this.state = State.STOPPED;
	*/
	//Mactrix changes and additions start
	//memory clean up
		this.config = null;
		this.initPTS = null;
		this.ontick = null;
		this.tracks = null;
	//this.hls = null;
	//Mactrix additions end
	}

  //Signal that video PTS was found
	onInitPtsFound(data) {
		let demuxerId = data.id;
		let	cc = data.frag.cc;
		let initPTS = data.initPTS;

		if(demuxerId === 'main') {
			//Always update the new INIT PTS
			//Can change due level switch
			this.initPTS[cc] = initPTS;
			logger.log(`InitPTS for cc:${cc} found from video track:${initPTS}`);

			//If we are waiting we need to demux/remux the waiting frag
			//With the new initPTS
			if (this.state === State.WAITING_INIT_PTS) {
				logger.log('sending pending audio frag to demuxer');
				this.state = State.FRAG_LOADING;

				//We have audio frag waiting or video pts
				//Let process it
				this.onFragLoaded(this.waitingFragment);

				//Lets clean the waiting frag
				this.waitingFragment = null;
			}
		}
	}

	startLoad(/*startPosition*/) {

	/* Mactrix lines removed, splitting load and fetch
		setting audio tracks already loads it, so we don't need to do anything in startLoad
		we still have to leave the function here for now, as HlsJs.startLoad calls startLoad in all the controllers
	if (this.tracks) {
	  var lastCurrentTime = this.lastCurrentTime;
	  this.stopLoad();
	  if (!this.timer) {
		this.timer = setInterval(this.ontick, 100);
	  }
	  this.fragLoadError = 0;
	  if (lastCurrentTime > 0 && startPosition === -1) {
		logger.log(`audio:override startPosition with lastCurrentTime @${lastCurrentTime.toFixed(3)}`);
		this.state = State.IDLE;
	  } else {
		this.lastCurrentTime = this.startPosition ? this.startPosition : startPosition;
		this.state = State.STARTING;
	  }
	  this.nextLoadPosition = this.startPosition = this.lastCurrentTime;
	  this.tick();
	} else {
	  this.startPosition = startPosition;
	  this.state = State.STOPPED;
	}
	*/
	}

  //Mactrix additions start
  //don't start fetch until all controllers are ready
	onStreamAllLevelsLoaded(data) {
		this.allLevelsLoaded = true;
		this.videoFragBuffered = false;

		if (this.tracks) {
			this.stopLoad();

			//Disabling this for now
			//resync level as we are now guaranteed to have the base PDT
			//this.hls.streamController.adjustStartByBasePdt(this.tracks[this.trackId].details, this.hls.streamCoordinator.basePdt);

			this.state = State.STARTING;
			this.lastCurrentTime = this.nextLoadPosition = this.startPosition = data.startTime; //derivedStartTime;
			this.fragLoadError = 0;
			this.unpauseController();

		}
		else {
			this.startPosition = data.startTime;
			this.state = State.STOPPED;
		}

		logger.log(`onStreamAllLevelsLoaded AUDIO this.startPosition: ${this.startPosition} this.lastCurrentTime: ${this.lastCurrentTime}`);
	}

  //fix desync
	onStreamDesync(data) {
		let i;
		let fragments = this.tracks[this.trackId].details.fragments;
		let totalDropDuration = 0;
		let duration = fragments[0].manifestDuration;

		//sum the total duration that was removed, then sub that from all frags
		for(i = 0; fragments.length > 1 && fragments[0].pdt < data.pdtToAlignTo - data.variance; i++) {
			fragments.splice(0, 1);
			totalDropDuration += duration;
			duration = fragments[0].manifestDuration;
		}

		if(i > 0) {
			let j;

			logger.log('audio PDT earlier than main PDT, adjusting audio timestamps');

			for(j = 0; j < fragments.length; j++) {
				fragments[j].index = j;
				fragments[j].start -= totalDropDuration;
				fragments[j].pdt -= totalDropDuration * 1000;
				fragments[j].sn -= i;
			}

			this.tracks[this.trackId].details.endSN -= i;
		}
	}

	pauseController() { //it is best to always use pause/unpause as otherwise weird bugs are likely...
		if(this.timer && !this._pausedTimer) {
			clearInterval(this.timer);
		}
		this.timer = null;
		this._pausedTimer = true;
	}

	unpauseController() { //it is best to always use pause/unpause as otherwise weird bugs are likely...
		if(!this.timer && this._pausedTimer && this.tracks) {
			this.timer = setInterval(this.ontick, 100);
			this._pausedTimer = false;
			this.tick();
		}
	}

	get pausedTimer() {
		return this._pausedTimer;
	}
  //Mactrix additions end

	stopLoad() {
		var frag = this.fragCurrent;
		if (frag) {
			logger.log('Audio resetting current frag load count as load was aborted');
			frag.loadCounter = 0;
			if (frag.loader) {
				frag.loader.abort();
			}
			this.fragCurrent = null;
		}
		this._fragPrevious = null;
		if (this.demuxer) {
			this.demuxer.destroy();
			this.demuxer = null;
		}
		this.state = State.STOPPED;
		this.timestampOffset = undefined;
	}

	set state(nextState) {
		if (this.state !== nextState) {
			const previousState = this.state;
			this._state = nextState;
			logger.log(`audio stream state: ${previousState}->${nextState} pausedTimer: ${this.pausedTimer}`);
		}
	}

	get state() {
		return this._state;
	}

	tick() {
		if(!this.pausedTimer) {
			this.ticks++;
			if (this.ticks === 1) {
				this.doTick();
				if (this.ticks > 1) {
					setTimeout(this.tick, 1);
				}
				this.ticks = 0;
			}
		}
		else {
			logger.log('Audio Ticking while paused');
		}
	}

	// called from doTick() when idle
	_doTickIdle() {
		const tracks = this.tracks;

		// audio tracks not received => exit loop
		if (!tracks) {
			logger.log('audio: No tracks. Idle exit');
			return;
		}

		// if video not attached AND
		// start fragment already requested OR start frag prefetch disable
		// exit loop
		// => if media not attached but start frag prefetch is enabled and start frag not requested yet, we will not exit loop
		let hls = this.hls;
		let config = hls.config;

		if (!this.media &&
			(this.startFragRequested || !config.startFragPrefetch)) {
			return;
		}

		// determine next candidate fragment to be loaded, based on current position and
		//  end of buffer position
		// if we have not yet loaded any fragment, start loading from start position

		//stop pos from moving back to 0 before first video frag has buffered
		let pos;

		if(this._bufferBeforeSeekingTime !== undefined && this._bufferBeforeSeekingApplied === false) {
			logger.log('audio: using bufferBeforeSeeking');
			pos = this._bufferBeforeSeekingTime;
			this._fragPrevious = null;
			this._bufferBeforeSeekingApplied = true;
		}
		else if(!this.videoFragBuffered) {
			pos = this.startPosition;
		}
		else if(this.loadedmetadata && this._videoSeekReady !== false) {
			pos = this.media.currentTime;
		}
		else {
			pos = this.nextLoadPosition;
		}

		let media = this.mediaBuffer ? this.mediaBuffer : this.media;
		let bufferInfo = BufferHelper.bufferInfo(media, pos, 0);
		let bufferLen = bufferInfo.len;
		let bufferEnd = bufferInfo.end;
		let maxBufLen = config.maxMaxBufferLength;
		let audioSwitch = this.audioSwitch;
		let trackId = this.trackId;
		let audioSwitchComplete = this._audioSwitchComplete;
		let desiredTime = bufferEnd;

		// if buffer length is less than maxBufLen try to load a new fragment
		if (trackId < tracks.length && (bufferLen < maxBufLen || this._bufferBeforeSeekingApplied === true)) {
			let trackDetails;
			trackDetails = tracks[trackId].details;
			// if track info not retrieved yet, switch state and wait for track retrieval
			if (typeof trackDetails === 'undefined') {
				this.state = State.WAITING_TRACK;
				return;
			}

			// we just got done loading the final fragment, check if we need to finalize media stream
			if (!audioSwitch && !trackDetails.live && this._fragPrevious && trackDetails.fragments[trackDetails.fragments.length - 1].loadCounter > 0) {
				// if everything (almost) til the end is buffered, let's signal eos
				// we don't compare exactly media.duration === bufferInfo.end as there could be some subtle media duration difference when switching
				// between different renditions. using half frag duration should help cope with these cases.

				if ((this.media.duration - bufferEnd) < this._fragPrevious.duration / 2) {
					// Finalize the media stream
					hls.trigger(Event.BUFFER_EOS, { type : 'audio' });
					this.state = State.ENDED;
					return;
				}
			}

			// find fragment index, contiguous with end of buffer position
			let fragments = trackDetails.fragments;
			let fragLen = fragments.length;
			let start = fragments[0].start;
			let end = fragments[fragLen - 1].start + fragments[fragLen - 1].duration;
			let findFragResults = undefined;
			let frag;

			// When switching audio track, reload audio as close as possible to currentTime
			if(!audioSwitchComplete) {
				desiredTime = pos;

				// if currentTime (pos) is less than alt audio playlist start time, it means that alt audio is ahead of currentTime
				if (trackDetails.PTSKnown && pos < start) {
					// if everything is buffered from pos to start or if audio buffer upfront, let's seek to start
					if (bufferInfo.end > start || bufferInfo.nextStart) {
						logger.log('alt audio track ahead of main track, seek to start of alt audio track');
						this.media.currentTime = start + 0.05;
					}
				}

				logger.log(`audio: Audio changing, next chunk will be selected at playhead pos: ${pos} currentTime: ${this.media.currentTime}`);

			}
			if (trackDetails.initSegment && !trackDetails.initSegment.data) {
				frag = trackDetails.initSegment;
			}
			// if bufferEnd before start of playlist, load first fragment
			else if (desiredTime <= start) {
				//Mactrix changes begin: disable for now, Don't think it's correct
				/*
				if(this.pdtDiff === undefined && this.initialPdt && hls.streamController && hls.streamController.initialPdt) {
					this.pdtDiff = this.initialPdt - hls.streamController.initialPdt;

					if(this.pdtDiff < 0 && fragments.length > 1) {
						hls.streamController._pdtAlign(fragments, trackDetails);
					}
				}
				*/
				//Mactrix changes end

				frag = fragments[0];

				/* Mactrix lines removed, this doesn't appear to be working correctly right now
				// it's been activating when there is alt audio at the current time, but didn't get buffered on first audio frag load
				if (trackDetails.live && frag.loadIdx && frag.loadIdx === this.fragLoadIdx) {
				  // we just loaded this first fragment, and we are still lagging behind the start of the live playlist
				  // let's force seek to start
				  const nextBuffered = bufferInfo.nextStart ? bufferInfo.nextStart : start;
				  logger.log(`no alt audio available @currentTime:${this.media.currentTime}, seeking @${nextBuffered + 0.05}`);
				  this.media.currentTime = nextBuffered + 0.05;
				  return;
				}
				*/
			}
			else if (this.forceStopFetching === true) {
				logger.log('audio: forceStopFetching. Idle exit');
				return;
			}
			else {
				findFragResults = hls.streamController._findFragment(
					start,
					this._fragPrevious,
					fragLen,
					fragments,
					desiredTime,
					end,
					trackDetails,
					pos,
					false,
					this.mediaBuffer
				);
				frag = findFragResults.frag;
				this._fragPrevious = findFragResults.fragPrevious;
			}
			//Mactrix line below changed, stop new frag selector loading frag at current end of live stream repeatedly but only if fragPrevious was previously valid
			//if(frag && ((!this._fragPrevious || !this._fragPrevious.pdt || !frag.pdt || this._fragPrevious.pdt !== frag.pdt) || !findFragResults.previouslyNoPrevious) ) {
			if(frag && (!findFragResults || findFragResults.previouslyNoPrevious || !findFragResults.noNewFrag) ) {
				//logger.log('      loading frag ' + i +',pos/bufEnd:' + pos.toFixed(3) + '/' + desiredTime.toFixed(3));
				if (frag.decryptdata && (frag.decryptdata.uri != null) && (frag.decryptdata.key == null)) {
					logger.log(`Audio loading key for ${frag.sn} of [${trackDetails.startSN} ,${trackDetails.endSN}],track ${trackId}`);
					this.state = State.KEY_LOADING;
					hls.trigger(Event.KEY_LOADING, { frag: frag });
				}
				else {
					logger.log(`Audio loading ${frag.sn} of [${trackDetails.startSN}, ${trackDetails.endSN}], track ${trackId}, pos:${pos}, desiredTime:${desiredTime.toFixed(3)}`);
					// ensure that we are not reloading the same fragments in loop ...
					if (this.fragLoadIdx !== undefined) {
						this.fragLoadIdx++;
					}
					else {
						this.fragLoadIdx = 0;
					}
					if (frag.loadCounter && this._bufferBeforeSeekingApplied !== true && audioSwitchComplete) {
						frag.loadCounter++;
						let maxThreshold = config.fragLoadingLoopThreshold;
						// if this frag has already been loaded fragLoadingLoopThreshold times (currently 3 ), and if it has been reloaded recently
						if (frag.loadCounter > maxThreshold && (Math.abs(this.fragLoadIdx - frag.loadIdx) < maxThreshold)) {
							hls.trigger(Event.ERROR, { type: ErrorTypes.MEDIA_ERROR, details: ErrorDetails.FRAG_LOOP_LOADING_ERROR, fatal: false, frag: frag });
							return;
						}
					}
					else {
						frag.loadCounter = 1;
					}
					frag.loadIdx = this.fragLoadIdx;
					this.fragCurrent = frag;
					this.startFragRequested = true;
					if (!isNaN(frag.sn)) {
						this.nextLoadPosition = frag.start + frag.duration;
					}
					hls.trigger(Event.FRAG_LOADING, { frag: frag });
					this.state = State.FRAG_LOADING;
				}
			}
			else {
				if (frag && this._fragPrevious) {
					logger.log(`audio: Frag loop prevention. frag ${frag} _fragPrevious.level ${this._fragPrevious.level} audioSwitch ${this.audioSwitch} frag.level ${frag.level} Idle exit`);
				}
			}
		}
	}

	doTick() {
		let track;

		switch(this.state) {
		case State.ERROR:			//don't do anything in error state to avoid breaking further ...
		case State.PAUSED:			//don't do anything in paused state either ...
		case State.BUFFER_FLUSHING:	// or buffering
			break;

		case State.STARTING:
			this.state = State.WAITING_TRACK;
			this.loadedmetadata = false;
			break;

		case State.IDLE:
			this._doTickIdle();
			break;

		case State.WAITING_TRACK:
			track = this.tracks[this.trackId];
			// check if playlist is already loaded
			if (track && track.details) {
				this.state = State.IDLE;
			}
			break;

		case State.FRAG_LOADING_WAITING_RETRY:
			{
				var now = performance.now();
				var retryDate = this.retryDate;
				let media = this.media;
				var isSeeking = media && media.seeking;
			// if current time is gt than retryDate, or if media seeking let's switch to IDLE state to retry loading
				if(!retryDate || (now >= retryDate) || isSeeking) {
					logger.log(`audioStreamController: retryDate reached, switch back to IDLE state`);
					this.state = State.IDLE;
				}
				break;
			}

		case State.WAITING_INIT_PTS:
		case State.STOPPED:
		case State.FRAG_LOADING:
		case State.PARSING:
		case State.PARSED:
		case State.ENDED:
			break;

		default:
			break;
		}
	}

	onMediaAttached(data) {
		var media = this.media = this.mediaBuffer = data.media;
		this.onvseeking = this.onMediaSeeking.bind(this);
		this.onvended = this.onMediaEnded.bind(this);

		this.onvseeked = this.onMediaSeeked.bind(this);
		media.addEventListener('seeked', this.onvseeked);
		media.addEventListener('seeking', this.onvseeking);
		media.addEventListener('ended', this.onvended);

		let config = this.config;
		if(this.tracks && config.autoStartLoad) {
			this.startLoad(config.startPosition);
		}
	}

	onMediaDetaching() {
		let media = this.media;
		if (media && media.ended) {
			logger.log('AUDIO MSE detaching and video ended, reset startPosition');
			this.startPosition = this.lastCurrentTime = 0;
		}

		// reset fragment loading counter on MSE detaching to avoid reporting FRAG_LOOP_LOADING_ERROR after error recovery
		let tracks = this.tracks;
		if (tracks) {
			// reset fragment load counter
			tracks.forEach(track => {
				if(track.details) {
					track.details.fragments.forEach(fragment => {
						fragment.loadCounter = undefined;
					});
				}
			});
		}
		// remove video listeners
		if (media) {
			media.removeEventListener('seeking', this.onvseeking);
			media.removeEventListener('seeked', this.onvseeked);
			media.removeEventListener('ended', this.onvended);

			this.onvseeking = this.onvseeked = this.onvended = null;
		}
		this.media = this.mediaBuffer = null;
		this.loadedmetadata = false;
		this.stopLoad();
	}

	onMediaSeeking() {
		if (this.media) {
			this.lastCurrentTime = this.media.currentTime;

			if(this.state !== State.PARSING) {
				this.state = State.IDLE;
			}

			if(this._fragPrevious) {
				this._fragPrevious = null;
			}
		}
	// avoid reporting fragment loop loading error in case user is seeking several times on same position
		if (this.fragLoadIdx !== undefined) {
			this.fragLoadIdx += 2 * this.config.fragLoadingLoopThreshold;
		}

		this.hls.trigger(Event.BUFFER_SOURCE_SEEKING); //Mactrix addition

	// tick to speed up processing
		this.tick();
	}

	onMediaSeeked() {
		//logger.log(`AUDIO media seeked to ${this.media.currentTime.toFixed(3)}`);
		if (this.hls && this.hls._inSlowDetach) {
			if (this.hls.streamCoordinator.checkReadyForDispose(undefined, true)) {
				logger.log('AUDIO slow detach seek finished');
				this.hls._doCompleteSlowDetach();
			}
		}
	}

	onMediaEnded() {
		// reset startPosition and lastCurrentTime to restart playback @ stream beginning
		this.startPosition = this.lastCurrentTime = 0;
	}

	onSeekReady() {
		this._videoSeekReady = undefined;
	}

	onAudioTracksUpdated(data) {
		logger.log('audio tracks updated');
		this.tracks = data.audioTracks;

		this.tracks.forEach(track => {
			track.deadFragList = [];
			track.containsGaps = false;
			track.gapList = []; //THIS IS TEMPORARY, REMOVE WHEN WE HAVE PROPER GAP HANDLING
		});
	}

	onManifestLoaded() {
		this._fragBufferCount = 0;
		this.cmaf = false;
	}

	onAudioTrackSwitching(data) {
		// if any URL found on new audio track, it is an alternate audio track
		var altAudio = !!data.url;
		this.trackId = data.id;
		this.state = State.IDLE;

		this.pendingData = [];

		//clear load counter on track switch to prevent false fragLoopLoadingErrors
		this._clearFragCounts(this);

		this.fragCurrent = null;
		this.state = State.PAUSED;
		this.waitingFragment = null;

		// destroy useless demuxer when switching audio to main
		if (!altAudio) {
			if (this.demuxer) {
				this.demuxer.destroy();
				this.demuxer = null;
			}
		}
		else {

//If all else fails we could just destroy...
//			if (this.demuxer) {
//				this.demuxer.destroy();
//				this.demuxer = null;
//			}



			// switching to audio track, start timer if not already started
			if (this.allLevelsLoaded) { //Mactrix line changed, don't start the timer until we're ready to fetch
				this.unpauseController();
			}
		}

		//should we switch tracks ?
		if(altAudio) {
			this.audioSwitch = true;
			this._audioSwitchComplete = false;
			//main audio track are handled by stream-controller, just do something if switching to alt audio track
			this.state = State.IDLE;
			// increase fragment load Index to avoid frag loop loading error after buffer flush
			if (this.fragLoadIdx !== undefined) {
				this.fragLoadIdx += 2 * this.config.fragLoadingLoopThreshold;
			}
		}

		/* Mactrix line removed, stop track switch from automatically starting fetching
		this.tick();
		*/
	}

	onAudioTrackLoaded(data) {
		let newDetails = data.details;
		let trackId = data.id;
		let track = this.tracks[trackId];
		let duration = newDetails.totalduration;
		let sliding = 0;

		logger.log(`onAudioTrackLoaded: track ${trackId} loaded [${newDetails.startSN},${newDetails.endSN}],duration:${duration}`);

		//store the base pdt ... this would cause problems if pdts were to appear mid stream .. shouldn't happen
		if(this.initialPdt === undefined && newDetails.fragments[0].pdt) {
			this.initialPdt = newDetails.fragments[0].pdt;
		}

		if (newDetails.live) {
			var curDetails = track.details;
			if (curDetails && newDetails.fragments.length > 0) {

				// we already have details for that level, merge them
				if(this.hls.streamCoordinator.basePdt) {
					this.hls.streamController.adjustStartByBasePdt(newDetails, this.hls.streamCoordinator.basePdt);
				}
				else {
					//This case shouldn't hit, but it will on startup. Often it's not an issue as it'll just do a no-offset
					//as needed, but in a sliding live recovery it's bad. Since we're creating PDTs always now this whole
					//case probably can be deleted and just make the no-PDT case do no adjustment, but more testing is required. - SIEG
					logger.log('onAudioTrackLoaded adjustStartBySlidingOffset NO BASEPDT YET');
					this.hls.streamController.adjustStartBySlidingOffset(curDetails, newDetails);
				}

				sliding = newDetails.fragments[0].start;

				if (newDetails.PTSKnown) {
					logger.log(`live audio playlist sliding:${sliding.toFixed(3)}`);
				}
				else {
					logger.log('live audio playlist - outdated PTS, unknown sliding');
				}
			}
			else {
				//if we know the base PDT we can sync and determine sliding
				if(this.hls.streamCoordinator.basePdt) {
					logger.log('live audio playlist - first load, calculating slide by syncing to base PDT');
					this.hls.streamController.adjustStartByBasePdt(newDetails, this.hls.streamCoordinator.basePdt);
					sliding = newDetails.fragments[0].start;
					logger.log(`live audio playlist sliding:${sliding.toFixed(3)}`);
				}
				else {
					newDetails.PTSKnown = false;
					logger.log('live audio playlist - first load, unknown sliding');
				}
			}
		}
		else {
			//resync VODs, if needed
			if(this.hls.streamCoordinator.basePdt) {
				this.hls.streamController.adjustStartByBasePdt(newDetails, this.hls.streamCoordinator.basePdt);
			}
			newDetails.PTSKnown = false;
		}

		track.gapList = [];

		newDetails.fragments.forEach((frag, index) => {
			if(frag.tagList.includes('GAP')) {
				this.hls.streamController.removeDeadFrag(index, newDetails.fragments);
				track.containsGaps = true;

				//check the frag that we just moved into this index
				while(newDetails.fragments[index] && newDetails.fragments[index].tagList.includes('GAP')) {
					this.hls.streamController.removeDeadFrag(index, newDetails.fragments);
				}

				if(newDetails.fragments[index]) {
					track.gapList.push({ start: newDetails.fragments[index].start - (newDetails.fragments[index].gap / 1000), end: newDetails.fragments[index].start });
				}
			}
			else if(frag.gap > 0) {
				//we haven't removed dead frags yet so a gap without an EXT-X-GAP marks a discontinuity
				//for now we need to mark this as we would a gap for the workaround seek
				track.containsGaps = true;
				track.gapList.push({ start: frag.start - (frag.gap / 1000), end: frag.start });
			}
		});

		track.deadFragList.forEach((deadSn) => {
			let index = newDetails.fragments.findIndex((element) => {
				return element.sn === deadSn;
			});

			if(index !== -1) {
				this.hls.streamController.removeDeadFrag(index, newDetails.fragments);
			}
		});

		//reconfirm first and last SN, in case there are dead frags at start or end
		newDetails.startSN = newDetails.fragments[0].sn;
		newDetails.originalEndSN = newDetails.endSN;
		newDetails.endSN = newDetails.fragments[newDetails.fragments.length - 1].sn;

		track.details = newDetails;

		// compute start position
		if (!this.startFragRequested) {
			// compute start position if set to -1. use it straight away if value is defined
			if (this.startPosition === -1) {
				// first, check if start time offset has been set in playlist, if yes, use this value
				let startTimeOffset = newDetails.startTimeOffset;

				if(!isNaN(startTimeOffset)) {
					logger.log(`start time offset found in playlist, adjust startPosition to ${startTimeOffset}`);
					this.startPosition = startTimeOffset;
				}
				else {
					this.startPosition = 0;
				}
			}
			this.nextLoadPosition = this.startPosition;
		}

		// only switch batck to IDLE state if we were waiting for track to start downloading a new fragment
		if (this.state === State.WAITING_TRACK) {
			this.state = State.IDLE;
		}

		this.hls.trigger(Event.AUDIO_TRACK_UPDATED, { details: newDetails, track: trackId, sliding: sliding }); //Mactrix line added, log end of track parse
	}

	onKeyLoaded() {
		if (this.state === State.KEY_LOADING) {
			this.state = State.IDLE;
			this.tick();
		}
	}

	onFragLoaded(data) {
		let fragCurrent = this.fragCurrent;
		let fragLoaded = data.frag;

		if (this.state === State.FRAG_LOADING &&
			fragCurrent &&
			fragLoaded.type === 'audio' &&
			fragLoaded.level === fragCurrent.level &&
			fragLoaded.sn === fragCurrent.sn
		) {
			let track = this.tracks[this.trackId];
			let details = track.details;
			let duration = details.totalduration;
			let trackId = fragCurrent.level;
			let sn = fragCurrent.sn;
			let cc = fragCurrent.cc;
			let audioCodec = this.config.defaultAudioCodec || track.audioCodec || 'mp4a.40.2';
			let stats = this.stats = data.stats;

			this._flushOnStoppedBuffering = {};

			if (this._waitForFlush) {
				logger.log('audio aborting parse due to flush');
				this._clearFragCounts(this);
				this._checkIfBufferReady();
			}
			else if (sn === 'initSegment') {
				this.state = State.IDLE;
				stats.tparsed = stats.tbuffered = performance.now();
				//details.initSegment.data = data.payload;
				details.initSegment.data = this.hls.streamController.insertPssh(data.payload, details.initSegment);
				//details.isCMAF = this.hls.streamController.isCMAF(details.initSegment.data);
				this.cmaf = this.hls.streamController.isCMAF(details.initSegment.data);
				this.hls.trigger(Event.FRAG_BUFFERED, { stats: stats, frag: fragCurrent, id : 'audio' });
				this.tick();  // probably not required but more tests are needed - SIEG
			}
			else {
				this.state = State.PARSING;
				// transmux the MPEG-TS data to ISO-BMFF segments
				this.appended = false;

				logger.log(`onFragLoaded: Loaded audio ${fragCurrent.sn} of [${details.startSN} ,${details.endSN}], track ${fragCurrent.level}, size ${stats.loaded} bytes, load time ${stats.tload - stats.tfirst}ms, latency ${stats.tfirst - stats.trequest}ms`);

				//Check if we have video initPTS
				// If not we need to wait for it
				let initPTS = this.initPTS[cc];
				let initSegmentData = details.initSegment ? details.initSegment.data : [];
				if (initSegmentData || initPTS !== undefined) {
					this.pendingBuffering = true;

					if(this.cmaf/*details.isCMAF*/) {
						if(details.initSegment.data) {
							let tracks = {};
							let initData = { tracks: tracks };
							initData.frag = fragLoaded;
							initData.id = 'audio';

							tracks.audio = {
								container: 'audio/mp4',
								codec: 'mp4a.40.2', //currentLevel.audioCodec,
								initSegment: details.initSegment.data,
								metadata: {
									channelCount: 2, //get the correct value!
								},
								//temporary hack for fairplay - DO NOT rely on this as it will be removed!
								levelkeys: details.initSegment.levelkeys,
							};

							if(!this.timestampOffset) {
								let timeScale = this.hls.streamController.getTimeScale(details.initSegment.data);
								this.timestampOffset = this.hls.streamController.getTimestampOffset(data.payload, timeScale);
							}

							this.onFragParsingInitSegment(initData);

							//only do this once per init segment
							//details.initSegment.data = null;
						}

						let payload = {
							data1: new Int8Array(data.payload),
							data2: null, //is ignored
							startPTS: fragCurrent.startDTS / 90e3,
							endPTS: fragCurrent.nextDTS / 90e3,
							startDTS: fragCurrent.startDTS / 90e3,
							endDTS: fragCurrent.nextDTS / 90e3,
							type: 'audio',
							nb: fragCurrent.frames,
							dropped: 0, //dropped
							duplicate: false, //would need to keep track of the last startDTS
							dts: fragCurrent.startDTS,
							frag: fragCurrent,
							id: 'audio',
						};

						this.onFragParsingData(payload);
						this.onFragParsed(payload);
					}
					else {
						if(!this.demuxer) {
							this.demuxer = new Demuxer(this.hls, 'audio');
						}

						logger.log(`Audio Demuxing ${sn} of [${details.startSN} ,${details.endSN}],track ${trackId}`);
						// time Offset is accurate if level PTS is known, or if playlist is not sliding (not live)
						let accurateTimeOffset = false; //details.PTSKnown || !details.live;
						this.demuxer.push(data.payload, initSegmentData, audioCodec, null, fragCurrent, duration, accurateTimeOffset, this.fragAborted, false);
						this.fragAborted = false;
						this._parsingDataCount = 0;
					}
				}
				else {
					logger.log(`unknown video PTS for continuity counter ${cc}, waiting for video PTS before demuxing audio frag ${sn} of [${details.startSN} ,${details.endSN}],track ${trackId}`);
					this.waitingFragment = data;
					this.state = State.WAITING_INIT_PTS;
				}
			}
		}
		this.fragLoadError = 0;
	}

	onFragParsingInitSegment(data) {
		const fragCurrent = this.fragCurrent;
		const fragNew = data.frag;
		if (fragCurrent &&
		data.id === 'audio' &&
		fragNew.sn === fragCurrent.sn &&
		fragNew.level === fragCurrent.level &&
		this.state === State.PARSING) {
			let tracks = data.tracks;

			// delete any video track found on audio demuxer
			if (tracks.video) {
				delete tracks.video;
			}

			// include levelCodec in audio and video tracks
			let track = tracks.audio;
			if(track) {
				track.levelCodec = 'mp4a.40.2';
				track.id = data.id;
				this.hls.trigger(Event.BUFFER_CODECS, tracks);
				logger.log(`audio track:audio,container:${track.container},codecs[level/parsed]=[${track.levelCodec}/${track.codec}]`);
				let initSegment = track.initSegment;
				if (initSegment) {
					let appendObj = { type: 'audio', data: initSegment, parent : 'audio', content : 'initSegment', sn : fragCurrent.sn };

					if (this.audioSwitch) {
						this.pendingData = [appendObj];
					}
					else {
						this.appended = true;
						// arm pending Buffering flag before appending a segment
						this.pendingBuffering = true;
						this.hls.trigger(Event.BUFFER_APPENDING, appendObj);
					}
				}
				//trigger handler right now
				this.tick(); // probably not required but more tests are needed - SIEG
			}
		}
	}

	onFragParsingData(data) {
		const fragCurrent = this.fragCurrent;
		const fragNew = data.frag;

		if (this._waitForFlush) {
			logger.log('audio aborting append due to flush');
			this._checkIfBufferReady();

			this._clearFragCounts(this);

			this.fragAborted = true;
		}
		else if (fragCurrent &&
			data.id === 'audio' &&
			data.type === 'audio' &&
			fragNew.sn === fragCurrent.sn &&
			fragNew.level === fragCurrent.level &&
			this.state === State.PARSING
		) {
			let hls = this.hls;

			if (isNaN(data.endPTS)) {
				data.endPTS = data.startPTS + fragCurrent.duration;
				data.endDTS = data.startDTS + fragCurrent.duration;
			}

			this._flushOnStoppedBuffering = ({ start: data.startPTS, end: data.endPTS });

			logger.log(`onFragParsingData Audio parsed ${data.type},PTS:[${data.startPTS.toFixed(3)},${data.endPTS.toFixed(3)}],DTS:[${data.startDTS.toFixed(3)}/${data.endDTS.toFixed(3)}],nb:${data.nb}`);

			let audioSwitch = this.audioSwitch;
			let media = this.media;
			let appendOnBufferFlush = false;

			//Only flush audio from old audio tracks when PTS is known on new audio track
			if(audioSwitch && media) {
				let trackId = this.trackId;

				if (media.readyState) {
					let currentTime = media.currentTime;
					logger.log('switching audio track : currentTime:' + currentTime);

					if (currentTime >= data.startPTS) {
						logger.log('switching audio track : flushing all audio');
						this.state = State.BUFFER_FLUSHING;
						hls.trigger(Event.BUFFER_FLUSHING, { startOffset: 0, endOffset: Number.POSITIVE_INFINITY, type : 'audio' });
						appendOnBufferFlush = true;
					}
					//Lets announce that the initial audio track switch flush occur
					this.audioSwitch = false;
					hls.trigger(Event.AUDIO_TRACK_SWITCHED, { id : trackId });
				}
				else {
					//Lets announce that the initial audio track switch flush occur
					this.audioSwitch = false;
					hls.trigger(Event.AUDIO_TRACK_SWITCHED, { id : trackId });
				}
			}


			let pendingData = this.pendingData;
			if(!this.audioSwitch) {
				[data.data1, data.data2].forEach(buffer => {
					if (buffer && buffer.length) {
						pendingData.push({
							type: data.type,
							data: buffer,
							parent : 'audio',
							content : 'data',
							sn: data.frag.sn,
							level : data.frag.level,
							start: data.startPTS,
							end: data.endPTS,
							dts: data.dts,
							targetDuration: data.frag.duration,
						});
					}
				});

				if (!appendOnBufferFlush && pendingData.length) {
					pendingData.forEach(appendObj => {
						// only append in PARSING state (rationale is that an appending error could happen synchronously on first segment appending)
						// in that case it is useless to append following segments
						if (this.state === State.PARSING) {
							// arm pending Buffering flag before appending a segment
							this.pendingBuffering = true;
							hls.trigger(Event.BUFFER_APPENDING, appendObj);
							this._parsingDataCount++;
						}
					});
					this.pendingData = [];
					this.appended = true;
				}
			}

			//trigger handler right now
			this.tick(); // probably not required but more tests are needed - SIEG
		}
	}

	onFragParsed(data) {
		const fragCurrent = this.fragCurrent;
		const fragNew = data.frag;

		if (fragCurrent &&
			data.id === 'audio' &&
			fragNew.sn === fragCurrent.sn &&
			fragNew.level === fragCurrent.level &&
			this.state === State.PARSING &&
			this._parsingDataCount > 0
		) {
			this.stats.tparsed = performance.now();
			this.state = State.PARSED;
			this._parsingDataCount = 0;
			this._checkAppendedParsed();
		}
		else if(fragCurrent &&
			data.id === 'audio' &&
			fragNew.sn === fragCurrent.sn &&
			fragNew.level === fragCurrent.level &&
			this.state === State.PARSING &&
			this._parsingDataCount === 0
		) {
			this.state = State.IDLE;
			this.fragCurrent = null;
			this._fragPrevious = null;
		}
	}

	//stop pos from moving back to 0 before first video frag has buffered
	onFragBuffered(data) {
		if(data.id === 'audio') {
			this._fragBufferCount++;
		}
		else if(!this.videoFragBuffered && data.id === 'main') {
			this.videoFragBuffered = true;
		}
	}

	onBufferCreated(data) {
		let audioTrack = data.tracks.audio;
		if (audioTrack) {
			this.mediaBuffer = audioTrack.buffer;

			if (this.timestampOffset) {
				this.mediaBuffer.timestampOffset = this.timestampOffset;
			}

			this.loadedmetadata = true;
		}
	}

	onBufferAppended(data) {
		if (data.parent === 'audio') {
			const state = this.state;
			if (state === State.PARSING || state === State.PARSED) {
				// check if all buffers have been appended
				this.pendingBuffering = (data.pending > 0);
				this._checkAppendedParsed();
			}
		}
	}

	_checkAppendedParsed() {
		if (this.state === State.PARSED && (!this.appended || !this.pendingBuffering)) {
			let frag = this.fragCurrent;

			if (frag) {
				this._fragPrevious = frag;

				let stats = this.stats;
				stats.tbuffered = performance.now();

				let hls = this.hls;
				hls.trigger(Event.FRAG_BUFFERED, { stats: stats, frag: frag, id : 'audio' });

				let media = this.mediaBuffer ? this.mediaBuffer : this.media;

				this._audioSwitchComplete = true;

				try {
					logger.log(`audio buffered : ${TimeRanges.toString(media.buffered)} sn : ${frag.sn}`);
				}
				catch(err) {
					logger.log(`audio buffered : {TimeRanges.toString(media.buffered)} failed. err ${err.message}`);
				}

				if(this._bufferBeforeSeekingTime !== undefined) {
					if (BufferHelper.isBuffered(media, this._bufferBeforeSeekingTime)) {
						logger.log(`bufferBeforeSeeking: Audio Ready.`);
						this._bufferBeforeSeekingTime = undefined;
						this._bufferBeforeSeekingApplied = undefined;
					}
					else if (this._bufferBeforeSeekingApplied === true) {
						let targetTime = this._bufferBeforeSeekingTime + 1;

						logger.log(`bufferBeforeSeeking: Buffered audio but desired time not found. Pushing forward target time to ${targetTime}.`);

						hls.bufferBeforeSeeking = targetTime;
					}
				}

				if (this.audioSwitch && this.appended) {
					this.audioSwitch = false;
					hls.trigger(Event.AUDIO_TRACK_SWITCHED, { id : this.trackId });
				}

				this.state = State.IDLE;
			}

			//trigger handler right now
			this.tick(); // probably not required but more tests are needed - SIEG
		}
	}

	onError(data) {
		let frag = data.frag;

		// don't handle frag error not related to audio fragment
		if (frag && frag.type !== 'audio') {
			return;
		}

		switch(data.details) {
		case ErrorDetails.FRAG_LOAD_ERROR:
		case ErrorDetails.FRAG_LOAD_TIMEOUT:
			if(!data.fatal) {
				let loadError = this.fragLoadError;
				if(loadError) {
					loadError++;
				}
				else {
					loadError = 1;
				}

				let config = this.config;
				if (loadError < 2) {
					this.fragLoadError = loadError;
					// reset load counter to avoid frag loop loading error
					frag.loadCounter = 0;
					// exponential backoff capped to config.fragLoadingMaxRetryTimeout
					var delay = Math.min(Math.pow(2, loadError - 1) * config.fragLoadingRetryDelay, config.fragLoadingMaxRetryTimeout);
					logger.warn(`audioStreamController: frag loading failed, retry in ${delay} ms`);
					this.retryDate = performance.now() + delay;
					// retry loading state
					this.state = State.FRAG_LOADING_WAITING_RETRY;
				}
				else if(this._fragBufferCount !== 0) {
					if(data.frag) {
						logger.warn(`audio stream controller,${data.details}: marking dead frag`);

						if(this.tracks[this.trackId]) {
							this.tracks[this.trackId].deadFragList.push(data.frag.sn);
							this.tracks[this.trackId].details = undefined; //wipe track details so we're forced to reload
							this.hls.audioTrackController.updateTrack(this.trackId);
						}

						this.retryDate = performance.now();
						this.state = State.WAITING_TRACK;
					}
				}
				else {
					logger.error(`audioStreamController: ${data.details} reaches max retry, redispatch as fatal ...`);
					// switch error to fatal
					data.fatal = true;
					this.state = State.ERROR;
				}
			}
			break;

		case ErrorDetails.AUDIO_TRACK_LOAD_ERROR:
		case ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:
			//If we can't get the audio track, mark as fatal
			//TODO: try alternate tracks in the rendition group if we have them
			if(this._fragBufferCount === 0) {
				data.fatal = true;
				this.state = State.ERROR;
			}
			else if(this.state !== State.ERROR) {
				this.state = State.IDLE;
			}

			logger.warn(`audioStreamController: ${data.details} while loading audio track,switch to ${this.state} state ...`);
			break;

		case ErrorDetails.FRAG_LOOP_LOADING_ERROR:
		case ErrorDetails.KEY_LOAD_ERROR:
		case ErrorDetails.KEY_LOAD_TIMEOUT:
			// when in ERROR state, don't switch back to IDLE state in case a non-fatal error is received
			if(this.state !== State.ERROR) {
				// if fatal error, stop processing, otherwise move to IDLE to retry loading
				this.state = data.fatal ? State.ERROR : State.IDLE;
				logger.warn(`audioStreamController: ${data.details} while loading frag,switch to ${this.state} state ...`);
			}
			break;

		case ErrorDetails.BUFFER_FULL_ERROR:
			// if in appending state
			if (data.parent === 'audio' && (this.state === State.PARSING || this.state === State.PARSED)) {
				const media = this.mediaBuffer;

				let desiredPlayPoint = this._bufferBeforeSeekingTime;
				if(desiredPlayPoint === undefined && this.media) {
					desiredPlayPoint = this.media.currentTime;
				}

				const currentTime = desiredPlayPoint;
				const mediaBuffered = media && BufferHelper.isBuffered(media, currentTime) && BufferHelper.isBuffered(media, currentTime + 0.5);

				//reset frag load counter
				this.fragCurrent.loadCounter = 0;

				// reduce max buf len if current position is buffered
				if (mediaBuffered) {
					const config = this.config;
					if(config.maxMaxBufferLength >= config.maxBufferLength) {
						// reduce max buffer length as it might be too high. we do this to avoid loop flushing ...
						config.maxMaxBufferLength /= 2;
						logger.warn(`audio:reduce max buffer length to ${config.maxMaxBufferLength}s`);
						// increase fragment load Index to avoid frag loop loading error after buffer flush
						this.fragLoadIdx += 2 * config.fragLoadingLoopThreshold;
					}
					//let flushRange = this._flushOnStoppedBuffering;
					this._skipAppendAfterFlush = true; //if we try to append data immediately after this flush, it will error again
					this._fragPrevious = null;
					this.fragCurrent = null;
					/* this.hls.trigger(Event.BUFFER_FLUSHING, { startOffset: flushRange.start, endOffset: flushRange.end, type: 'audio' });
					this.state = State.IDLE; */
					this.state = State.BUFFER_FLUSHING;
					this.hls.trigger(Event.BUFFER_FLUSHING, { startOffset: 0, endOffset: Number.POSITIVE_INFINITY, type : 'audio' });
				}
				else {
					// current position is not buffered, but browser is still complaining about buffer full error
					// this happens on IE/Edge, refer to https://github.com/video-dev/hls.js/pull/708
					// in that case flush the whole audio buffer to recover
					logger.warn('buffer full error also desired time is not buffered, flush audio buffer');
					this.fragCurrent = null;
					// flush everything
					this.state = State.BUFFER_FLUSHING;
					this.hls.trigger(Event.BUFFER_FLUSHING, { startOffset: 0, endOffset: Number.POSITIVE_INFINITY, type : 'audio' });
				}

				if (this._bufferBeforeSeekingApplied === true) {
					this._bufferBeforeSeekingApplied = false;
					logger.log('Audio: onBufferFull Rescheduling bufferBeforeSeeking');
				}
			}
			break;

		default:
			break;
		}
	}

	onBufferFlushed() {
		let pendingData = this.pendingData;

		if(this.state === State.BUFFER_FLUSHING && this.hls.bufferController.readyForData === true && this._waitForFlush) {
			this.endBufferWait();
			this.state = State.IDLE;
		}
		else if (pendingData && pendingData.length && !this._skipAppendAfterFlush) {
			logger.log('appending pending audio data on Buffer Flushed');
			pendingData.forEach(appendObj => {
				this.hls.trigger(Event.BUFFER_APPENDING, appendObj);
			});
			this.appended = true;
			this.pendingData = [];
			this.state = State.PARSED;
		}
		else {
			this._skipAppendAfterFlush = false;
			// move to IDLE once flush complete. this should trigger new fragment loading
			this.state = State.IDLE;
			// reset reference to frag
			this._fragPrevious = null;
			this.tick(); // probably not required but more tests are needed - SIEG
		}
	}

	onBufferWait() {
		var frag = this._fragCurrent;

		logger.log('Audio: BufferWait');

		if (frag) {
			if (frag.loader) {
				frag.loader.abort();
			}
			this._fragCurrent = null;
			if (this._bufferBeforeSeekingApplied === true) {
				this._bufferBeforeSeekingApplied = false;
				logger.log('Audio: onBufferWait Rescheduling bufferBeforeSeeking');
			}
		}

		//All other cases should switch to FLUSHING
		if (this.state === State.FRAG_LOADING || this.state === State.KEY_LOADING || this.state === State.FRAG_LOADING_WAITING_RETRY) {
			this.state = State.BUFFER_FLUSHING;
		}

		if (this._waitForFlush) {
			logger.warn('Audio: onBufferWait Already waiting');
		}
		this._waitForFlush = true; //Should only set it to true here
	}

	endBufferWait() {
		if (this._waitForFlush) {
			logger.log('Audio: end BufferWait No longer waiting');
		}
		this._waitForFlush = false; //Should only set it to false here
	}

	set bufferBeforeSeeking(time) {
		logger.log(`audio bufferBeforeSeeking set to ${time}`);
		this._bufferBeforeSeekingTime = time;
		this._bufferBeforeSeekingApplied = false;
		this._videoSeekReady = false;

		if (this._fragCurrent && this._fragCurrent.loader) {
			this._fragCurrent.loader.abort();
		}
		this._fragCurrent = null;
		this._fragPrevious = null;
		this.state = State.IDLE;

		this.unpauseController();  //the audio controller will unpause without an unpause, but it should make seeking slightly faster
	}


	get bufferBeforeSeeking() {
		return this._bufferBeforeSeekingTime;
	}


	_checkIfBufferReady() {
		if (this.hls.bufferController.readyForData === true) {
			this.endBufferWait();
			this.state = State.IDLE;
		}
		else {
			this.state = State.BUFFER_FLUSHING;
		}
	}


	_clearFragCounts(stream) {
		var tracks = stream.tracks;
		logger.log( `Audio: Clearing frag load counts`);
		if (tracks) {
			// reset fragment load counter
			tracks.forEach(track => {
				if(track.details) {
					track.details.fragments.forEach(fragment => {
						fragment.loadCounter = undefined;
					});
				}
			});
		}
	}


}
export default AudioStreamController;



// WEBPACK FOOTER //
// ./src/hlsjs/controller/audio-stream-controller.js